import React from "react";
import moment from "moment";
import AttachmentFile from "../../Images/attachment.png";
import { DisplayMsg } from "../../services/toastService";
import { BASE_FILE_URL, setUrl } from "../../handlers";

export default function MessageBox(props) {
  const CurMessage = props.item.commentData;

  const resolutionShow = (event) => {
    const data = {
      event,
      comments: CurMessage.COMMENTS,
      resolution_seqNumb: CurMessage.RESOLUTION_SEQ_NUM,
      comment_seqNumb: CurMessage.SEQ_NUM,
    };
    props.resolutionCallback(data);
  };

  const DownloadAttachment = async (e, commentSeqNum, ticketNumber) => {
    try {
      e.preventDefault();
      const data = new FormData();
      data.append("commentSeqNum", commentSeqNum);
      data.append("ticketNumber", ticketNumber);
      document.getElementById("loader").style.display = "block";

      const result = await fetch(
        setUrl("TICKETDETAIL", "DOWNLOAD_TICKET_MSG_ATTACHMENTS", true),
        {
          method: "POST",
          body: data,
        }
      );

      const response = await result.json();

      if (response && response.status) {
        const downloadQueue = response.FilesData.map((file) => ({
          url: `${BASE_FILE_URL}${file.FILE_DIRECTORY}&filename=${file.FILE_NAME}`,
          filename: file.FILE_NAME,
        }));

        async function downloadNext() {
          if (downloadQueue.length > 0) {
            const { url, filename } = downloadQueue.shift();
            try {
              const response = await fetch(url);
              const blob = await response.blob();
              const objectUrl = URL.createObjectURL(blob);

              const a = document.createElement("a");
              a.href = objectUrl;
              a.download = filename;
              a.target = "_blank";
              a.click();

              URL.revokeObjectURL(objectUrl);

              await new Promise((resolve) => setTimeout(resolve, 1000)); // Wait for 1 second between downloads
              await downloadNext(); // Proceed to download the next file
            } catch (error) {
              console.error(`Error downloading ${filename}:`, error);
              // Handle the error as needed
            }
          } else {
            DisplayMsg("1", "Files have been downloaded successfully.");
            document.getElementById("loader").style.display = "none";
          }
        }

        await downloadNext(); // Start the download process
      } else {
        DisplayMsg("2", response.Message);
        document.getElementById("loader").style.display = "none";
      }
    } catch (error) {
      console.error("Unable to process the request:", error);
      DisplayMsg("2", "Unable to Process the Request");
      document.getElementById("loader").style.display = "none";
    }
  };

  return (
    <div className="tab-content">
      <div className="tab-pane active">
        <div className="row">
          <div className="col-md-12 col-sm-12 mb-2">
            <div className="commentsBox">
              <div className="commentHeader">
                <div>
                  <a href="javascript:;">
                    {CurMessage.ENTERED_BY_NAME
                      ? CurMessage.ENTERED_BY_NAME
                      : ""}
                  </a>
                  &nbsp; added a comment -&nbsp;
                  <a href="javascript:;">
                    {moment(CurMessage.ENTERED_DATE).format(
                      "MM/DD/YYYY hh:mm:ss A"
                    )}
                  </a>
                  {CurMessage.isAttachmentExist === "Y" ? (
                    <span
                      onClick={(e) =>
                        DownloadAttachment(
                          e,
                          CurMessage.SEQ_NUM,
                          CurMessage.PARENT_TICKET
                        )
                      }
                      title="Download Attachment(s)"
                      role="button"
                    >
                      &nbsp; &nbsp;
                      <img
                        alt="attachment"
                        src={AttachmentFile}
                        className="IconDocuments"
                      />
                      <p className="attachment-count  d-inline pb-3">
                        [{CurMessage.AttachmentCount}]
                      </p>
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                <div className="d-flex">
                  {CurMessage.USER_NOTIFIED === "Y" ? (
                    <div className="mr-5" style={{ fontSize: "12px" }}>
                      [User Notified]
                    </div>
                  ) : (
                    ""
                  )}

                  {!(
                    props.item.resolutionAdded &&
                    props.item.resolutionAdded.length > 0
                  ) ? (
                    <div className="d-flex">
                      {!(
                        props.item.resolutionAdded &&
                        props.item.resolutionAdded.length > 0
                      ) ? (
                        <input
                          className="mx-2"
                          type="checkbox"
                          COMMENT_SEQ_NUM={CurMessage.SEQ_NUM}
                          comments={encodeURIComponent(CurMessage.COMMENTS)}
                          checked={CurMessage.isCheck}
                          onClick={(e) => resolutionShow(e)}
                         />
                      ) : (
                        ""
                      )}
                      Add to Resolution
                    </div>
                  ) : (
                    ""
                  )}

                  {CurMessage.RESOLUTION === "Y" && (
                    <div className="d-flex">
                      <input
                        type="checkbox"
                        className="mx-2"
                        RESOLUTION_SEQ_NUM={CurMessage.RESOLUTION_SEQ_NUM}
                        COMMENT_SEQ_NUM={CurMessage.SEQ_NUM}
                        comments={encodeURIComponent(
                          CurMessage.RESOLUTION_COMMENTS
                        )}
                        des={encodeURIComponent(
                          CurMessage.RESOLUTION_TICKET_DES
                        )}
                        checked
                        disabled
                       />
                      <span>Add to Resolution</span>
                    </div>
                  )}
                </div>

                {CurMessage.VIEWABLE_BY === "I" ? (
                  <span>[Visible to internal users]</span>
                ) : (
                  ""
                )}
              </div>
              <div className="commentBody">
                <div
                  style={{ lineHeight: "1.5" }}
                  dangerouslySetInnerHTML={{ __html: CurMessage.COMMENTS }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
